module.exports = __webpack_public_path__ + "static/media/photo47.b84bafe4.jpg";